<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        {{ $t("profile.sections.log.connection") }}
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="filter"
          append-icon="search"
          :label="$t('profile.sections.log.filter')"
          single-line
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="log_headers"
          :items="log_datas"
          :items-per-page="10"
          :search="filter"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileLogConnector } from "../Database/ProfileLogConnector.js";

export default {
  data() {
    return {
      profileConnector: new ProfileLogConnector(this.$store.state.user),
      filter: "",
      log_headers: [
        { text: this.$t("profile.sections.user.login"), value: "login" },
        {
          text: this.$t("profile.sections.log.date-connect"),
          value: "dt_connect",
        },
      ],
      log_datas: [],
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getConnectionLogs();
    }
  },
  methods: {
    getConnectionLogs() {
      this.profileConnector
        .getConnectionLogs()
        .then((logs) => {
          this.log_datas = logs;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
